import { cfgToThemeCdnPath } from '@infinitro/config';
import { Verbiage } from '@infinitro/content';
export const createRocketbetCanonicalItems = () => [
    {
        id: 'welcome-deposit-bonus',
        promotion: {
            id: 'welcome-deposit-bonus',
            title: Verbiage.welcome_bonus,
            startDate: new Date('2026-01-01T00:00:00Z'),
            description: Verbiage.up_to_3000_bonus_on_your_first_3_deposits,
            buttonText: Verbiage.claim,
            url: '/casino/',
            banner: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/deposit_bonus/deposit_bonus-detail.png'),
            action: true,
            footerText: Verbiage.rocketbet_promotions_footer_text_3000_welcome_bonus
        },
        surfaces: {},
        order: { promotions: 0 }
    },
    {
        id: 'minted-mike',
        promotion: {
            id: 'minted-mike',
            title: Verbiage.minted_mike,
            description: Verbiage.minted_mike_description,
            buttonText: Verbiage.play_now,
            url: '/p/hacksaw-gaming/minted-mike/',
            conditionalUrl: {
                loggedInUrl: '/player/p/hacksaw-gaming/minted-mike/',
                loggedOutUrl: '/p/hacksaw-gaming/minted-mike/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/minted_mike/minted_mike_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/minted_mike/minted_mike_mobile.png'),
            startDate: new Date('2026-08-27T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/minted_mike/minted_mike_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/minted_mike/minted_mike_mobile.png'),
            badgeText: Verbiage.new_release
        },
        order: { topSection: 0 }
    },
    {
        id: 'eastern-fury',
        promotion: {
            id: 'eastern-fury',
            title: Verbiage.eastern_fury,
            description: Verbiage.eastern_fury_description,
            buttonText: Verbiage.play_now,
            url: '/p/pragmatic-play/Eastern-Fury/',
            conditionalUrl: {
                loggedInUrl: '/player/p/pragmatic-play/Eastern-Fury/',
                loggedOutUrl: '/p/pragmatic-play/Eastern-Fury/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/eastern_fury/eastern_fury_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/eastern_fury/eastern_fury_mobile.png'),
            startDate: new Date('2026-08-27T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/eastern_fury/eastern_fury_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/eastern_fury/eastern_fury_mobile.png'),
            badgeText: Verbiage.new_release,
            titleSingleLine: true
        },
        order: { topSection: 1 }
    },
    {
        id: 'outsourced-2-balkan-engineering',
        promotion: {
            id: 'outsourced-2-balkan-engineering',
            title: Verbiage.outsourced_2_balkan_engineering,
            description: Verbiage.outsourced_2_balkan_engineering_description,
            buttonText: Verbiage.play_now,
            url: '/p/nolimit-city/outsourced_2_balkan_engineering/',
            conditionalUrl: {
                loggedInUrl: '/player/p/nolimit-city/outsourced_2_balkan_engineering/',
                loggedOutUrl: '/p/nolimit-city/outsourced_2_balkan_engineering/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/outsourced_2_balkan_engineering/outsourced_2_balkan_engineering_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/outsourced_2_balkan_engineering/outsourced_2_balkan_engineering_mobile.png'),
            startDate: new Date('2026-08-18T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/outsourced_2_balkan_engineering/outsourced_2_balkan_engineering_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/outsourced_2_balkan_engineering/outsourced_2_balkan_engineering_mobile.png'),
            badgeText: Verbiage.new_release
        },
        order: { topSection: 2 }
    },
    {
        id: 'epic-ze-zeus',
        promotion: {
            id: 'epic-ze-zeus',
            title: Verbiage.epic_ze_zeus,
            description: Verbiage.epic_ze_zeus_description,
            buttonText: Verbiage.play_now,
            url: '/p/hacksaw-gaming/epic_ze_zeus/',
            conditionalUrl: {
                loggedInUrl: '/player/p/hacksaw-gaming/epic_ze_zeus/',
                loggedOutUrl: '/p/hacksaw-gaming/epic_ze_zeus/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/epic_ze_zeus/epic_ze_zeus_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/epic_ze_zeus/epic_ze_zeus_mobile.png'),
            startDate: new Date('2026-08-18T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/epic_ze_zeus/epic_ze_zeus_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/epic_ze_zeus/epic_ze_zeus_mobile.png'),
            badgeText: Verbiage.new_release,
            titleSingleLine: true
        },
        order: { topSection: 3 }
    },
    {
        id: 'evoplay-promotion',
        promotion: {
            id: 'evoplay-promotion',
            title: Verbiage.evoplay_has_landed,
            description: Verbiage.evoplay_has_landed_description,
            buttonText: Verbiage.play_now,
            url: '/p/evoplay/',
            conditionalUrl: {
                loggedInUrl: '/player/p/evoplay/',
                loggedOutUrl: '/p/evoplay/'
            },
            bannerBig: cfgToThemeCdnPath('/promotions/evoplay_promotion/evoplay_promotion_desktop.png'),
            banner: cfgToThemeCdnPath('/promotions/evoplay_promotion/evoplay_promotion_mobile.png'),
            startDate: new Date('2026-08-06T00:00:00Z')
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/evoplay_promotion/evoplay_promotion_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/evoplay_promotion/evoplay_promotion_mobile.png'),
            badgeText: Verbiage.featured_provider,
            titleLogo: cfgToThemeCdnPath('/promotions/evoplay_promotion/evoplay_promotion_logo.svg')
        },
        order: { topSection: 5 }
    },
    {
        id: 'tournaments',
        promotion: {
            id: 'tournaments',
            title: Verbiage.weekly_races,
            description: Verbiage.weekly_races_description_2,
            buttonText: Verbiage.start_now,
            url: '/tournaments/#/tournaments/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/races/races_mobile.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/races/races_desktop.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_1500_every_week
        },
        topSection: {
            title: Verbiage.rocket_races,
            description: Verbiage.win_real_cash_prizes_every_week,
            backgroundImage: cfgToThemeCdnPath('/promotions/races/races_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/races/races_mobile.png'),
            badgeText: Verbiage.promotion,
            buttonText: Verbiage.join_the_races,
            link: '/tournaments/#/tournaments/',
            startDate: new Date('2026-06-29T00:00:00Z')
        },
        order: { promotions: 1, topSection: 4 }
    },
    {
        id: 'jackpot',
        promotion: {
            id: 'jackpot',
            title: Verbiage.rocket_jackpot_million_title,
            description: Verbiage.rocket_jackpot_million_description,
            buttonText: Verbiage.play_now,
            url: '/promotion-page/jackpot/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/jackpot/jackpot.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/jackpot/jackpot-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_all_caps
        },
        order: { promotions: 2 }
    },
    {
        id: 'raffles',
        promotion: {
            id: 'raffles',
            title: Verbiage.weekly_raffle,
            description: Verbiage.weekly_raffle_description,
            buttonText: Verbiage.enter_now,
            url: '/tournaments/#/raffles/',
            startDate: new Date('2026-06-29T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/raffles/raffles.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_500_cash_prize
        },
        topSection: {
            title: Verbiage.weekly_raffle,
            description: Verbiage.weekly_raffle_description,
            backgroundImage: cfgToThemeCdnPath('/promotions/raffles/raffles_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/raffles/raffles_mobile.png'),
            badgeText: Verbiage.promotion,
            buttonText: Verbiage.join_the_raffle,
            startDate: new Date('2026-06-29T00:00:00Z')
        },
        order: { promotions: 3, topSection: 6 }
    },
    {
        id: 'weekly-prizes',
        promotion: {
            id: 'weekly-prizes',
            title: Verbiage.rocket_weekly_prizes_title,
            description: Verbiage.rocket_weekly_prizes_description,
            buttonText: Verbiage.join_now,
            url: '/promotion-page/weekly-prizes/',
            startDate: new Date('2026-03-04T18:01:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/weekly_prizes/weekly_prizes-detail.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_daily_rewards
        },
        order: { promotions: 4 }
    },
    {
        id: 'rewards-program',
        promotion: {
            id: 'rewards-program',
            title: Verbiage.rewards_program,
            description: Verbiage.rewards_program_description,
            buttonText: Verbiage.more_info,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            customTitleWidth: '70%',
            banner: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_vip_galaxy
        },
        topSection: {
            backgroundImage: cfgToThemeCdnPath('/promotions/rewards_program/rewards_program.png'),
            badgeText: Verbiage.exclusive
        },
        order: { promotions: 5, topSection: 7 }
    },
    {
        id: 'inner-circle-telegram',
        promotion: {
            id: 'inner-circle-telegram',
            title: Verbiage.rocket_inner_circle_telegram_title,
            description: Verbiage.rocket_inner_circle_telegram_description,
            buttonText: Verbiage.join,
            url: 'https://t.me/+Zr6A6OTvsvJjYmJi',
            startDate: new Date('2026-06-25T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            banner: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_mobile.png'),
            bannerBig: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_desktop.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_exclusive_bonuses
        },
        topSection: {
            title: Verbiage.rocket_inner_circle_telegram_title,
            description: Verbiage.rocket_inner_circle_telegram_description,
            backgroundImage: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_desktop.png'),
            backgroundImageMobile: cfgToThemeCdnPath('/promotions/inner_circle_telegram/inner_circle_telegram_mobile.png'),
            badgeText: Verbiage.exclusive,
            buttonText: Verbiage.join,
            link: 'https://t.me/+Zr6A6OTvsvJjYmJi',
            startDate: new Date('2026-06-25T00:00:00Z')
        },
        order: { promotions: 6, topSection: 8 }
    },
    {
        id: 'rakeboost-promo',
        promotion: {
            id: 'rakeboost-promo',
            title: Verbiage.rocket_rakeboost_promo_title,
            description: Verbiage.rocket_rakeboost_promo_description,
            buttonText: Verbiage.rocket_boost_up,
            url: '/vip/',
            startDate: new Date('2026-01-01T00:00:00Z'),
            action: true,
            useUrlForDetail: true,
            conditionalUrl: {
                loggedInUrl: '/vip-dashboard/',
                loggedOutUrl: '/vip/'
            },
            banner: cfgToThemeCdnPath('/promotions/rakeboost_promo/rakeboost_promo.png'),
            footerText: Verbiage.rocketbet_promotions_footer_text_boost_your_rewards
        },
        order: { promotions: 7 }
    }
];
